export const MONTHS = [
  {
    label: "ENERO",
    value: "ENERO",
    id: 1
  },
  {
    label: "FEBRERO",
    value: "FEBRERO",
    id: 2
  },
  {
    label: "MARZO",
    value: "MARZO",
    id: 3
  },
  {
    label: "ABRIL",
    value: "ABRIL",
    id: 4
  },
  {
    label: "MAYO",
    value: "MAYO",
    id: 5
  },
  {
    label: "JUNIO",
    value: "JUNIO",
    id: 6
  },
  {
    label: "JULIO",
    value: "JULIO",
    id: 7
  },
  {
    label: "AGOSTO",
    value: "AGOSTO",
    id: 8
  },
  {
    label: "SEPTIEMBRE",
    value: "SEPTIEMBRE",
    id: 8
  },
  {
    label: "OCTUBRE",
    value: "OCTUBRE",
    id: 8
  }
]